export default "__VITE_ASSET__CSCZ5K00__"